export enum AccountRoleEnum {
  SIGNER,
  DESIGNATED,
  PLANNER,
  CONTACT,
}
